import React from "react";
import BuyerSidebar from "./Sidebar";

const BuyerLayout = ({
    children,
    paddingStyle = styles.defaultPadding
}) => {
    return (
        <div style={styles.layoutContainer}>
            <BuyerSidebar />
            <div style={styles.mainContent}>
                <div style={paddingStyle}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default BuyerLayout;

const styles = {
    layoutContainer: {
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: "#FFFFFF"
    },
    mainContent: {
        marginLeft: 250,
        flex: 1
    },
    defaultPadding: {
        padding: 30
    }
};
